import { render, staticRenderFns } from "./TakenSurvey.vue?vue&type=template&id=9fd55954&"
import script from "./TakenSurvey.vue?vue&type=script&lang=ts&"
export * from "./TakenSurvey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports